import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { ResponsiveBar } from '@nivo/bar';
import I18n from '../../../../../../components/shared/i18n/I18n.component';
import colors from '../../../../../../config/colors';

const MiniBarCardComponent = (props: any) => {
	const barChartData = props.barChartData || [];
	const companyColorMapping = props.companyColorMapping || {};

	// Extract all unique company names (keys) from all objects, excluding 'date'
	const barChartKeys = Array.from(
		new Set(
			barChartData.flatMap((item: any) => Object.keys(item).filter((key: string) => key !== 'date'))
		)
	);

	// Normalize data so all objects have the same keys (with 0 as default)
	const normalizedBarChartData = barChartData.map((item: any) => {
		const normalized: any = { date: item.date };
		
		// Add all keys, using 0 as default if key doesn't exist
		barChartKeys.forEach((key: string) => {
			normalized[key] = item[key] ?? 0;
		});
		
		return normalized;
	});


	return (
		<View style={styles.container}>
			<View >
				<I18n size={14} weight='bold'>
					{props.title || 'Title'}
				</I18n>
			</View>

			<View style={styles.chartContainer}>
				<ResponsiveBar
					data={normalizedBarChartData}
					keys={barChartKeys}
					indexBy='date'
					margin={{ top: 20, bottom: 40 , right: 40, left: 40 }}
					padding={0.8}
					groupMode='stacked'
					colors={(bar) => companyColorMapping[bar.id] || '#cccccc'}
					animate={false}
					enableLabel={false}
					enableGridY={false}
					enableGridX={false}
					axisBottom={{
						tickSize: 0,
						tickPadding: 10,
					}}
					theme={{
						axis: {
							ticks: {
								text: {
									fontSize: 12,
									fontWeight: 'lighter',
									fill: '#565864',
									fontFamily: 'Rubik',
								},
							},
						},
					}}
					axisLeft={null}
                    tooltip={({ id, value, color, indexValue }) => (
                        <div
                            style={{
                                padding: '12px',
                                background: 'white',
                                border: '1px solid #ccc',
                                borderRadius: 6,
                                boxShadow: '2px 4px 2px 0 rgba(0,0,0,0.16)',
                            }}
                        >
                            <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                                <View style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' }}>
                                    <View style={{ width: 8, height: 8, borderRadius: 100, backgroundColor: color, marginLeft: 8 }}>
                                    </View>
                                    <I18n size={12} weight='400' color={colors.darkGrey}>{id}</I18n>
                                </View>
                                <I18n size={12} weight='400' color={colors.tooltipPercentage}>{value}%</I18n>
                            </View>
                        </div>
                    )}
				/>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		paddingVertical: 24,
		gap: 24,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'white',
        borderRadius: 5,
        flex: 1,
	},
	chartContainer: {
		height: 310,
		width: '100%',
		backgroundColor: 'white',
	},
});

export default MiniBarCardComponent;
